const en = {
  common: {
    close: "Close",
    enabled: "Enabled",
    disabled: "Disabled",
  },
  header: {
    slogan:
      "One of the largest collections of exercises and exam sheets - practice, explanations, and quizzes.",
    loggedAs: "Logged in as:",
    guestMode: "You are in guest mode",
    roleStudent: "Student",
    roleParent: "Parent",
    roleTutor: "Tutor",
    roleAdmin: "Admin",
    home: "Home",
    logout: "Log out",
    login: "Log in",
    register: "Create account",
    studentPanel: "Student panel",
    parentPanel: "Parent panel",
    tutorPanel: "Tutor panel",
    userPanel: "User panel",
    adminPanel: "Admin panel",
    investorPanel: "Investor panel",
    guestModeShort: "Guest mode",
    scrollTop: "Scroll to top",
    hideBar: "Hide bar",
    showBar: "Show bar",
  },
  feedback: {
    buttonTitle: "Report an issue or share feedback",
    scrollTopTitle: "Go to top of page",
    settingsTitle: "Settings",
    settingsBackgroundTitle: "Background settings",
    settingsGrid: "Background grid",
    settingsVariant: "Background variant",
    settingsVariantDefault: "Default (black / white)",
    settingsVariantNavy: "Navy / light blue",
    settingsVariantGreen: "Dark green / light green",
    settingsTheme: "Interface theme",
    settingsThemeDark: "Dark mode",
    settingsThemeLight: "Light mode",
    settingsHelp:
      "Variants are normalized across themes. For example, default means black in dark mode and white in light mode.",
    settingsLanguage: "Interface language",
    reportTitle: "Report an issue or share feedback",
    typeBug: "Exercise bug",
    typeSuggestion: "Suggestion",
    typeOther: "Other",
    messagePlaceholder:
      "Briefly describe the issue or suggestion.\nIf it is an exercise bug: explain what is wrong (e.g. wrong answer / typo / chart).",
    screenshotLabel: "Screenshot / image (optional)",
    addFile: "Add file",
    screenshotHelp1: "You can add a screenshot showing the issue.",
    screenshotHelp2:
      "TIP (Windows): Win + Shift + S -> then paste here with Ctrl + V (you can also drag and drop an image).",
    screenshotHelp3: "Limit: {count} images, max 2MB each.",
    remove: "Remove",
    errorPrefix: "Error:",
    sent: "Sent. Thank you!",
    clear: "Clear",
    sending: "Sending...",
    send: "Send",
    errorsOnlyImages: "Images only (PNG/JPG/WebP).",
    errorsMaxImages: "Maximum {count} images.",
    errorsImageTooBig: "Image is too large (max 2MB).",
    errorsImageTooBigConverted: "Image is too large after conversion (max 2MB).",
    errorsMinMessage: "Please enter a short message (min. 3 characters).",
    errorsSendFailed: "Could not send.",
  },
  userAccount: {
    title: "User panel",
    loggedAs: "Logged in as:",
    home: "Home",
    tabSummary: "Summary",
    tabSubscription: "My subscription",
    tabPassword: "Change password",
    tabProfile: "Profile data",
    tabFeedback: "My reports",
    statusActive: "Status: active until {date}{sku}",
    statusInactive: "Status: inactive",
    statusLoading: "Status: ...",
    cardSubTitle: "My subscription",
    cardSubDesc: "Check plan status, payment history and manage your subscription.",
    cardPwdTitle: "Change password",
    cardPwdDesc: "Increase account security by changing your password.",
    cardProfileTitle: "Profile data",
    cardProfileDesc: "Update email, display name and other data.",
    cardFeedbackTitle: "My reports",
    cardFeedbackDesc: "Check status of reported issues and admin replies.",
  },
  studentDashboard: {
    title: "Your progress",
    tutoring: "Tutoring",
    tutoringPanel: "Tutoring panel",
    viewSnapshot: "View attempt snapshot",
    noSnapshot: "No saved preview",
    last: "last",
    best: "best",
    lastBest: "last (best)",
    completed: "Completed",
    notCompleted: "Not completed",
    lockedSoon: "(coming soon)",
    lockedTitle: "This subtopic is currently unavailable (coming soon).",
    inviteAcceptError: "Could not accept invitation: {message}",
    inviteRejectError: "Could not reject invitation: {message}",
    tutorInviteAcceptError: "Could not accept tutor invitation: {message}",
    tutorInviteRejectError: "Could not reject tutor invitation: {message}",
    fallbackError: "Error",
  },
  cards: {
    subtopics: "subtopics",
    topics: "topics",
    avgOnlyCompleted: "Average success rate (completed only)",
    avgShort: "avg {value}%",
  },
  invites: {
    parentsTitle: "Invitations from parents:",
    tutorsTitle: "Invitations from tutors:",
    accept: "Accept",
    reject: "Reject",
    assignedParents: "Assigned parents:",
  },
  languages: {
    pl: "Polski",
    en: "English",
  },
};

export default en;
